import { Heading } from '@/modules/ui/components/heading/Heading';
import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';

export const EmptyState = () => (
  <div className="flex flex-col gap-2 p-7 text-center">
    <img
      src="/copilot/loading_static.png"
      alt="Finny icon"
      className="mx-auto h-8 w-8 object-contain"
    />
    <Heading variant="h2" className="text-primary-600">
      Hi, I&apos;m Finny
    </Heading>
    <Paragraph variant="body" className="text-primary-600">
      I&apos;m your AI assistant that helps you find the best candidates for
      your job. How can I help you today?
    </Paragraph>
  </div>
);
